import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { useResource } from 'app';
import { PageHeader, PageTitle } from 'components/Page';

function Subject({ campaignId }) {
  const campaign = useResource('campaign', 'single', `/advertising-campaigns/${campaignId}`);

  const campaignData = campaign.body.data;

  return campaignData.subject || '[بدون عنوان]';
}

function CampaignSummary({ campaignId }) {
  return (
    <PageHeader>
      <PageTitle>
        موضوع کمپین: &nbsp;
        <Suspense fallback={'...'}>
          <Subject campaignId={campaignId} />
        </Suspense>
      </PageTitle>
    </PageHeader>
  );
}

CampaignSummary.propTypes = {
  campaignId: PropTypes.number.isRequired
};

export default CampaignSummary;
